import './AnipoPrint4.scss';
import {useEffect, useState} from "react";
import numericFunction from "../../../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../../../utils/CommaSeparator";

const AnipoPrint4 = (props) => {

  const [componentData, setComponentData] = useState({})
  const [sumPrice, setSumPrice] = useState("")

  useEffect(() => {
    setComponentData(props.data)

    let flag = 0
    props.data.products.forEach((v) => {
      flag = flag + (+v.totalPrice)
    })
    setSumPrice(Math.round(flag))
  }, []);

  debugger

  try {
    return (
      <div className="main-print-factor">
        {Object.keys(componentData).length > 0 &&
          <table className="sell-factor-print-table">

            <thead>
            <tr>
              <th className="th-main-head">
                <div className="logo-header">
                  {componentData?.logo !== false &&
                    <img src={componentData?.logo} alt={"logo"}/>
                  }
                  <h6>{componentData?.source.shopName}</h6>
                </div>

                <div className="date-header">
                  <div className={"inline-text"}>
                    <p>شماره سفارش :</p>
                    <p>{numericFunction.e2p(componentData?.orderId)}</p>
                  </div>
                  <div className={"inline-text"}>
                    <p>تاریخ :</p>
                    <p>{numericFunction.e2p(componentData?.date)}</p>
                  </div>
                </div>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <th className={"th-address"}>
                <div className="box-address">
                  <div className={"inline-text"}>
                    <p>گیرنده :</p>
                    <h6>{componentData?.destination.name}</h6>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p> استان :</p>
                      <h6>{componentData?.destination.province}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p> نام شهر :</p>
                      <h6>{componentData?.destination.city}</h6>
                    </div>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p>کد پستی :</p>
                      <h6>{componentData?.destination.postalCode !== null ? numericFunction.e2p(componentData?.destination.postalCode) : ""}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p>شماره تماس :</p>
                      <h6>{numericFunction.e2p(componentData?.destination.callNumber)}</h6>
                    </div>
                  </div>
                  <div className={"inline-text"} style={{alignItems: 'flex-start'}}>
                    <p>آدرس</p>
                    <p>:</p>
                    <h6>{numericFunction.e2p(componentData?.destination.address)}</h6>
                  </div>
                </div>

                <div className="box-address">
                  <div className={"inline-text"}>
                    <p>فرستنده :</p>
                    <h6>{componentData?.source.shopName}</h6>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p> استان :</p>
                      <h6>{componentData?.source.province}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p> نام شهر :</p>
                      <h6>{componentData?.source.city}</h6>
                    </div>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p>سایت :</p>
                      <h6>{componentData?.source.site}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p>شماره تماس :</p>
                      <h6>{numericFunction.e2p(componentData?.source.callNumber)}</h6>
                    </div>
                  </div>
                  <div className={"inline-text"} style={{alignItems: 'flex-start'}}>
                    <p>آدرس</p>
                    <p>:</p>
                    <h6>{numericFunction.e2p(componentData?.source.address)}</h6>
                  </div>
                </div>
              </th>
            </tr>

            <tr>
              <th>
                <table className="product-table">
                  <thead>
                  <tr>
                    <th className="th-table-in">
                      <ul>
                        <li style={{width: '7%'}}>ردیف</li>
                        <li style={{width: '10%'}}>کد کالا</li>
                        <li style={{width: '33%'}}>نام محصول</li>
                        <li style={{width: '10%'}}>مبلغ</li>
                        <li style={{width: '10%'}}>مقدار</li>
                        <li style={{width: '15%'}}>واحد</li>
                        <li style={{width: '15%'}}>مبلغ کل</li>
                      </ul>
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr>
                    <th className="th-middle-data">
                      {componentData?.products.map((v, index) =>
                        <ul>
                          <li style={{width: '7%'}}>{numericFunction.e2p(index + 1)}</li>
                          <li style={{width: '10%'}}>{numericFunction.e2p(v?.code)}</li>
                          <li style={{width: '33%'}}>{v?.name}</li>
                          <li style={{width: '10%'}}>{formatToPersianAddComma(v?.price)}</li>
                          <li style={{width: '10%'}}>{formatToPersianAddComma(v?.weight)}</li>
                          <li style={{width: '15%'}}>{numericFunction.e2p(v?.unit)}</li>
                          <li style={{width: '15%'}}>{formatToPersianAddComma(v?.totalPrice)}</li>
                        </ul>
                      )}
                    </th>
                  </tr>
                  </tbody>

                  <tfoot>
                  <tr>
                    <th className="th-table-in">
                    </th>
                  </tr>
                  </tfoot>
                </table>
              </th>
            </tr>

            <tr>
              <th className={"th-price"}>
                <div className="box-price-bot">
                  <div className="inline-price">
                    <h6> هزینه بسته بندی و ارسال</h6>
                    <p>{formatToPersianAddComma(componentData?.sendPrice)}</p>
                  </div>
                  {componentData?.discountPrice > 0 && (
                    <div className="inline-price">
                      <h6>مبلغ تخفیف (کد)</h6>
                      <p>{formatToPersianAddComma(componentData?.discountPrice)}</p>
                    </div>
                  )}
                  <div style={{ width: '100%', borderBottom: '0.5px solid #646464', margin: '4px 0' }}></div>
                  <div className="inline-price">
                    <h6 style={{ fontWeight: 'bold' }}>مجموع مبلغ نهایی</h6>
                    <p style={{ fontWeight: 'bold' }}>
                      {formatToPersianAddComma(+sumPrice + +componentData?.sendPrice - +(componentData?.discountPrice || 0))}
                    </p>
                  </div>
                </div>
                <div className="signature-box">
                  <h6>امضای گیرنده :</h6>
                </div>
              </th>
            </tr>
            </tbody>

          </table>
        }
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default AnipoPrint4;